import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';

import { font } from '@styles/fonts';

import { HeaderTypes } from '@v2/context/Times/page/interfaces';

const Header = ({ name, status, statusColor, C }: HeaderTypes) => {
  return (
    <View style={{ paddingHorizontal: scale(15) }}>
      <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary') }]}>{i18n.t(name)}</Text>
      <Text style={[font['Headline'], { color: C(statusColor) }]}>{i18n.t(status)}</Text>
    </View>
  );
};

export default Header;
